import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {SelectComponent} from './select.component';
import {ReactiveFormsModule} from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatButtonModule} from '@angular/material/button';
import {ButtonModule} from '../../../modules/core/component/button/button.module';

@NgModule({
    declarations: [
        SelectComponent,
    ],
    exports: [
        SelectComponent,
    ],
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatIconModule,
        NgxMatSelectSearchModule,
        MatSlideToggleModule,
        MatGridListModule,
        MatButtonModule,
        ButtonModule,
    ]
})
export class SelectModule {}
